module.exports = __webpack_public_path__ + "static/media/magento.fb80a46f.png";